// Native webview bridge for the FAQ page (the app's FAQ webview activity):
//  - close the webview -> `onWebClose`
//  - email inquiry      -> `sendEmail` (base64-encoded JSON), matching the
//    original Zendesk footer.hbs encoding.

import { isIOS, osName } from "react-device-detect";

function isApple() {
  return isIOS || osName === "iOS" || osName === "Mac OS";
}

// Install the device back-button handler the app calls (`WebBridge.onBackPress`)
// and ensure the lifecycle hooks (`pause`/`resume`) exist as no-ops so they
// don't throw. Pages call this with their own handler: the list closes the
// webview (faqClose), the detail page goes back to the list.
export function setBackHandler(onBackPress) {
  const wb = window.WebBridge || {};
  wb.onBackPress = onBackPress;
  if (typeof wb.pause !== "function") wb.pause = function () {};
  if (typeof wb.resume !== "function") wb.resume = function () {};
  window.WebBridge = wb;
}

// Close the webview. Used by the header back button and WebBridge.onBackPress.
export function faqClose() {
  try {
    if (isApple()) {
      window.webkit.messageHandlers.onWebClose.postMessage("");
    } else {
      window.Android.onWebClose();
    }
  } catch (e) {
    /* not in the app webview */
  }
}

// Email inquiry: post base64( JSON.stringify({ category }) ) to the app.
export function sendEmail(category) {
  try {
    const jsonB64 = btoa(unescape(encodeURIComponent(JSON.stringify({ category: category }))));
    if (isApple()) {
      window.webkit.messageHandlers.sendEmail.postMessage(jsonB64);
    } else {
      window.Android.sendEmail(jsonB64);
    }
  } catch (e) {
    /* not in the app webview */
  }
}
